var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
        (_vm.$store.state.storeAuth.userProfile.isSuperAdmin &&
          _vm.$store.state.storeAuth.userProfile.client ==
            _vm.$store.state.storeClient.client.basicSettings.name) || _vm.$store.state.storeAuth.userProfile.isSuperStoreAdmin
      )?_c('v-btn',{staticStyle:{"margin-top":"35px"},attrs:{"fab":"","absolute":"","top":"","right":"","small":"","outlined":"","color":"primary","to":_vm.path}},[_c('v-icon',{attrs:{"medium":"","color":"primary"}},[_vm._v("mdi-pencil")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }